'use client'

import { type BlogListPage, type BlogNavigation } from 'cms-types'
import { usePathname } from 'next/navigation'
import { useCallback } from 'react'
import { type LoadableComponentProps, TagList } from 'ui'

import { pageToUrl } from '@/cms/helpers'

type BlogNavigationProps = LoadableComponentProps<{
  menu?: BlogNavigation['menu']
  itemCount: Record<string, number>
}>

export default function BlogNavigation({ data, loading }: BlogNavigationProps) {
  const pathname = usePathname()
  const checkIsLinkActive = useCallback(
    (href: string) => {
      const route = href.split('/').at(-1) ?? ''

      return pathname.includes(route)
    },
    [pathname],
  )

  if (loading) {
    return (
      <TagList
        asLinks
        listClassName='flex scroll-smooth grow-0 gap-2 px-5 flex-wrap overflow-x-auto xl:gap-2 xl:px-10 scroll-bar-hide snap-x'
        itemClassName='snap-center'
        loading={loading}
      />
    )
  }

  const { menu, itemCount } = data

  return (
    menu != null && (
      <TagList
        asLinks
        listClassName='flex scroll-smooth grow-0 gap-2 px-5 flex-wrap overflow-x-auto xl:gap-2 xl:px-10 scroll-bar-hide snap-x'
        itemClassName='snap-center'
        data={{
          tags:
            menu?.map(({ title, category }) => {
              const url = pageToUrl(category) ?? ''
              const slug = (category.value as BlogListPage).slug

              return {
                text: `${title} (${itemCount[slug]})`,
                url: url,
                isActive: checkIsLinkActive(url),
                dataTestId: 'blog-category-link',
              }
            }) ?? [],
        }}
      />
    )
  )
}
